{
  document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".accordion-item");
    if (accordionItems.length > 0) {
      accordionItems[0].classList.add("open");
    }
    accordionItems.forEach((item) => {
      const header = item.querySelector(".accordion-item-header");
      header.addEventListener("click", () => {
        document.querySelectorAll(".accordion-item").forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains("open")) {
            otherItem.classList.remove("open");
          }
        });
        item.classList.toggle("open");
      });
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
  const contentBoxes = document.querySelectorAll(".reviws-Contnt");

  contentBoxes.forEach(function (contentBox) {
    const para = contentBox.querySelector("p");

    // Wait for layout to settle (important for clamp to apply)
    requestAnimationFrame(() => {
      const isClamped = para.scrollHeight > para.clientHeight;

      if (isClamped) {
        const toggleBtn = document.createElement("span");
        toggleBtn.className = "read-toggle";
        toggleBtn.textContent = "Read More";

        contentBox.appendChild(toggleBtn);

        toggleBtn.addEventListener("click", function () {
          contentBox.classList.toggle("expanded");
          toggleBtn.textContent = contentBox.classList.contains("expanded")
            ? "Read Less"
            : "Read More";
        });
      }
    });
  });
});

}
{
  document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".reviews_slide", {
    slidesPerView: 3,
    spaceBetween: 20,
    direction: "horizontal",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    speed: 800,
    breakpoints: {
      150: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 1.8,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
});

}

{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".testimonailsSlider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.3,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.1,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 25,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}

{

document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance = null;
  function initSwiper() {
    if (window.innerWidth <= 1034 && !swiperInstance) {
      swiperInstance = new Swiper(".video__slider", {
        direction: "horizontal",
        speed: 800,
        breakpoints: {
          150: { slidesPerView: 1.2, spaceBetween: 10 },
          576: { slidesPerView: 2, spaceBetween: 10 },
        },
      });
    } else if (window.innerWidth > 1034 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
  initSwiper();
  window.addEventListener("resize", initSwiper);
});}

{
  const toggleMenu = document.querySelector(".menuIcon");
  const slideBar = document.querySelector(".site-menu");
  const menuOvrly = document.querySelector(".menuOvrly");
  const RemoveSid = document.querySelector(".close_icon_area");
  if(toggleMenu){
    toggleMenu.addEventListener("click", () => {
    slideBar.classList.toggle("active");
  });
  }
  menuOvrly.addEventListener("click", () => {
    slideBar.classList.remove("active");
  });
  RemoveSid.addEventListener("click", () => {
    slideBar.classList.remove("active");
  });
  document.querySelectorAll(".sildebar ul li a").forEach((e) => {
    e.addEventListener("click", () => {
      slideBar.classList.remove("active");
    });
  });
}


